import { RouteConfig } from 'vue-router'
import newTermIcon from '@/assets/images/icon_new_term_2022_deactive@2x.png'
import newTermIconActive from '@/assets/images/icon_new_term_2022_active@2x.png'

const Layout = () => import('../views/Layout.vue')

const Intro = () => import('../views/new-term-plan-2022/Intro.vue')

const Create = () => import('../views/autumn-2022/Create.vue')

const List = () => import('../views/autumn-2022/List.vue')

const Detail = () => import('../views/autumn-2022/Detail.vue')

export const createRoute: RouteConfig = {
  path: 'create',
  name: 'autumn2022_homework_create',
  component: Create,
  props: (route) => {
    return { ...route.query }
  },
  meta: {
    title: '新学期计划',
  },
}

export const listRoute: RouteConfig = {
  path: 'list',
  name: 'autumn2022_homework_list',
  component: List,
  meta: {
    title: '计划列表',
    // showMenu: true,
  },
  props: (route) => {
    return { ...route.query }
  },
}

export const introRoute: RouteConfig = {
  path: 'new-term-plan',
  name: 'new_term_plan',
  component: Intro,
  meta: {
    title: '新学期计划',
  },
}

export const detailRoute: RouteConfig = {
  path: 'detail',
  name: 'detail',
  component: Detail,
  props: (route) => {
    return { ...route.query }
  },
}

export const autumn2022Route: RouteConfig = {
  path: '/autumn-2022',
  name: 'autumn-2022',
  component: Layout,
  meta: {
    title: '新学期计划',
    icon: newTermIcon,
    iconActive: newTermIconActive,
    // showMenu: true,
  },
  children: [listRoute, createRoute, introRoute, detailRoute],
}

export default [autumn2022Route]
